// legacy contracts may still contain CSS shorthand colors
const SHORT_HEX_COLOR_REGEX = /^#([0-9a-f])([0-9a-f])([0-9a-f])$/i;

export function normalizeHexColor(color) {
  if (typeof color !== 'string') return color;

  const normalizedColor = color.replace(SHORT_HEX_COLOR_REGEX, '#$1$1$2$2$3$3');

  if (normalizedColor !== color) {
    console.trace('normalized invalid hex color', {
      previousValue: color,
      normalizedValue: normalizedColor
    });
  }

  return normalizedColor;
}
